import React, { useRef } from "react";
import PropTypes from "prop-types";
import { Trans } from "@lingui/macro";

import { Popover, POPOVER_POSITIONS } from "widgets/popover";
import { Menu, MenuItem } from "widgets/menu";
import { KfIcon, KF_ICONS, ICON_SIZE, ICON_STROKE } from "widgets/kficon";

import { handleCommunityRedirection } from "@base/common/community/index.js";

import styles from "../styles.css";

export const Help = () => {
  const currentClosePopup = useRef(null);

  return (
    <div className={styles.helpNav}>
      <Popover
        className={styles.helpNavPopover}
        position={POPOVER_POSITIONS.BOTTOM_RIGHT}
        destroyOnClose={false}
        targetRenderer={({ closePopup }) => {
          currentClosePopup.current = closePopup;
          return (
            <div className={styles.helpNavbutton}>
              <KfIcon
                icon={KF_ICONS.HELP}
                size={ICON_SIZE.SIZE_20}
                stroke={ICON_STROKE.LIGHT}
                className={styles.helpMenuIcon}
              />
            </div>
          );
        }}
      >
        <Menu>
          <MenuItem
            className={styles.helpMenuItem}
            onClick={() => handleCommunityRedirection(true)}
            data-heaplocator="navSupport"
          >
            <div className={styles.chipWrapper}>
              <KfIcon
                icon={KF_ICONS.HELP}
                size={ICON_SIZE.SIZE_16}
                stroke={ICON_STROKE.LIGHT}
              />
              <div className={styles.helpMenuText}>
                <p className="base500">
                  <Trans>Get help</Trans>
                </p>
                <p className={`tiny ${styles.description}`}>
                  <Trans>
                    Visit Kissflow Community: Access support, documentation,
                    request features, and more.
                  </Trans>
                </p>
              </div>
              <div className={styles.linkIconWrapper}>
                <KfIcon
                  icon={KF_ICONS.EXTERNAL_LINK}
                  size={ICON_SIZE.SIZE_16}
                  stroke={ICON_STROKE.LIGHT}
                />
              </div>
            </div>
          </MenuItem>
        </Menu>
      </Popover>
    </div>
  );
};

Help.propTypes = {
  icon: PropTypes.node,
  hasProductUpdate: PropTypes.bool
};
